import { render } from "./job-detail.vue?vue&type=template&id=ed8975b6"
import script from "./job-detail.vue?vue&type=script&lang=js"
export * from "./job-detail.vue?vue&type=script&lang=js"

import "./job-detail.vue?vue&type=style&index=0&id=ed8975b6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__